import { render } from "./select-part.vue?vue&type=template&id=fba10520"
import script from "./select-part.vue?vue&type=script&lang=js"
export * from "./select-part.vue?vue&type=script&lang=js"

import exportComponent from "/home/devbuildsseatshopcom/dev.builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__